export default reactive({
  minLength: {
    'message-key': 'dbc-text-pw-error-min-length',
    validate: (v: string) => (v && v.length >= 8 ? true : false),
  },
  containsNumber: {
    'message-key': 'dbc-text-pw-error-min-one-number',
    validate: (v: string) => /[0-9]/.test(String(v)),
  },
  containsLowerCase: {
    'message-key': 'dbc-text-pw-error-min-one-lower-char',
    validate: (v: string) => /[\p{Ll}]/u.test(v ? v : ''),
  },
  containsUpperCase: {
    'message-key': 'dbc-text-pw-error-min-one-upper-char',
    validate: (v: string) => /[\p{Lu}]/u.test(v),
  },
  containsSpecialCharacter: {
    'message-key': 'dbc-text-pw-error-min-one-special-char',
    validate: (v: string) => /[^\p{L}\p{N}]/u.test(v),
  },
})
